/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Build_Clear_FiltersInputs */

const en_us2_plan_build_clear_filters = /** @type {(inputs: Plan_Build_Clear_FiltersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clear filters`)
};

const pt_br2_plan_build_clear_filters = /** @type {(inputs: Plan_Build_Clear_FiltersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Limpar filtros`)
};

const es_419_plan_build_clear_filters = /** @type {(inputs: Plan_Build_Clear_FiltersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Borrar filtros`)
};

const pt_pt2_plan_build_clear_filters = /** @type {(inputs: Plan_Build_Clear_FiltersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Limpar filtros`)
};

const fr_fr2_plan_build_clear_filters = /** @type {(inputs: Plan_Build_Clear_FiltersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Effacer les filtres`)
};

const de_de2_plan_build_clear_filters = /** @type {(inputs: Plan_Build_Clear_FiltersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filter zurücksetzen`)
};

const it_it2_plan_build_clear_filters = /** @type {(inputs: Plan_Build_Clear_FiltersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Azzera filtri`)
};

/**
* | output |
* | --- |
* | "Clear filters" |
*
* @param {Plan_Build_Clear_FiltersInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_build_clear_filters = /** @type {((inputs?: Plan_Build_Clear_FiltersInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Build_Clear_FiltersInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_build_clear_filters(inputs)
	if (locale === "es-419") return es_419_plan_build_clear_filters(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_build_clear_filters(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_build_clear_filters(inputs)
	if (locale === "de-DE") return de_de2_plan_build_clear_filters(inputs)
	if (locale === "it-IT") return it_it2_plan_build_clear_filters(inputs)
	return en_us2_plan_build_clear_filters(inputs)
});
export { plan_build_clear_filters as "plan-build.clear_filters" }